var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _line3, _line4, _path16, _line5, _line6, _line7, _line8, _rect7, _rect8, _rect9, _path17, _rect10, _rect11, _rect12, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.382 218.143L340.869 132.198C340.796 131.005 341.562 128.796 345.214 129.513L516.95 129.513C518.716 129.14 522.914 129.692 525.578 134.884L569.492 195.314C570.844 197.179 574.367 200.909 577.638 200.909L634.643 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.155 218.367L295.644 132.341C295.731 131.146 294.989 128.935 291.326 129.652L119.453 129.652C117.69 129.279 113.483 129.832 110.757 135.03L66.1215 195.531C64.7468 197.398 61.1789 201.133 57.9051 201.133L0.854912 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 317.069L294.56 324.231C294.635 325.276 294.158 327.365 291.656 327.365L221.663 327.365C221.022 327.365 219.265 326.111 217.369 321.098C216.953 319.997 214.995 315.175 212.016 307.893M0.737039 221.948L20.821 221.948M138.139 189.943L138.118 193.524L138.16 186.138M138.139 189.943L149.504 189.943M138.139 189.943L126.774 189.943M149.504 189.943L160.869 189.943C162.985 189.943 164.463 192.33 164.937 193.524C175.141 218.249 191.762 258.563 203.57 287.302M149.504 189.943L149.483 193.524L149.525 186.138M126.774 189.943L115.409 189.943C113.967 189.793 110.404 190.301 107.692 193.524L97.1586 205.945M126.774 189.943L126.754 193.524L126.796 186.138M97.1586 205.945L86.6252 218.367C85.4158 219.561 82.6121 221.948 81.0727 221.948L60.9888 221.948M97.1586 205.945L107.621 205.945L86.6957 205.945M40.9049 221.948L40.8782 226.648M40.9049 221.948L60.9888 221.948M40.9049 221.948L20.821 221.948M60.9888 221.948L60.9621 226.648M20.821 221.948L20.7943 226.648M212.016 307.893L223.698 307.893M212.016 307.893C210.775 304.858 209.356 301.396 207.797 297.597M207.797 297.597L223.756 297.597M207.797 297.597C206.48 294.387 205.064 290.937 203.57 287.302M203.57 287.302L223.815 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.829 317.069L339.788 324.231C339.702 325.276 340.155 327.365 342.656 327.365L412.65 327.365C413.291 327.365 415.062 326.111 417.015 321.098C417.444 319.997 419.456 315.175 422.518 307.893M634.772 221.948L614.689 221.948M497.734 189.943L497.714 193.524L497.756 186.138M497.734 189.943L486.369 189.943M497.734 189.943L509.099 189.943M486.369 189.943L475.004 189.943C472.888 189.943 471.383 192.33 470.895 193.524C460.41 218.249 443.332 258.563 431.197 287.302M486.369 189.943L486.349 193.524L486.391 186.138M509.099 189.943L520.464 189.943C521.908 189.793 525.465 190.301 528.14 193.524L538.533 205.945M509.099 189.943L509.079 193.524L509.12 186.138M538.533 205.945L548.925 218.367C550.121 219.561 552.897 221.948 554.437 221.948L574.521 221.948M538.533 205.945L528.07 205.945L548.995 205.945M594.605 221.948L594.578 226.648M594.605 221.948L574.521 221.948M594.605 221.948L614.689 221.948M574.521 221.948L574.494 226.648M614.689 221.948L614.662 226.648M422.518 307.893L410.836 307.893M422.518 307.893C423.794 304.858 425.252 301.396 426.853 297.597M426.853 297.597L410.894 297.597M426.853 297.597C428.207 294.387 429.662 290.937 431.197 287.302M431.197 287.302L410.953 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.345 202.028L319.351 24.7674C319.355 24.0213 319.845 22.5292 321.769 22.5292L524.051 22.5292C526.296 22.6039 530.789 21.9921 530.806 18.9482C530.824 15.9043 530.869 7.8321 530.89 4.17647C530.815 3.28121 531.242 1.49069 533.551 1.49069L625.502 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.837 202.028L318.34 113.398L318.843 24.7674C318.848 24.0213 318.376 22.5292 316.455 22.5292L114.479 22.5292C112.238 22.6039 115.85 21.8119 115.867 18.7681C115.884 15.7242 115.93 7.65196 115.951 3.99632C116.036 3.10106 107.538 1.49069 105.233 1.49069L11.0157 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.594 337.884L317.548 345.941C317.376 347.881 318.092 351.76 322.325 351.76L497.188 351.76C498.47 351.909 501.954 351.044 505.637 346.389L563.291 274.32C564.34 273.052 566.872 270.516 568.604 270.516L634.268 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.592 337.884L316.546 345.941C316.695 347.881 315.936 351.76 311.703 351.76L136.84 351.76C135.556 351.909 132.082 351.044 128.452 346.389L71.616 274.32C70.5809 273.052 68.0778 270.516 66.346 270.516L0.68242 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.76 22.7529)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.34863 22.7532)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 11.1352,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 293.385 249.368)",
    fill: "url(#paint0_linear_422_3382)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 20.8785,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 293.32 264.679)",
    fill: "url(#paint1_linear_422_3382)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 19.4866,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 317.385 249.49)",
    fill: "url(#paint2_linear_422_3382)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 36.1894,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 317.32 264.801)",
    fill: "url(#paint3_linear_422_3382)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 11.1352,
    transform: "matrix(0.999979 0.00507419 0.00421726 -0.999994 339.385 249.602)",
    fill: "url(#paint4_linear_422_3382)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00001,
    height: 20.8785,
    transform: "matrix(0.999979 0.00507419 -0.00421726 0.999994 339.32 264.912)",
    fill: "url(#paint5_linear_422_3382)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M537.499 22.0002H547.499",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.999 22.0002H98.999",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M511.999 22.5002C513.166 22.5002 517.099 22.5002 523.499 22.5002C529.899 22.5002 531.166 20.8335 530.999 20.0002C530.999 16.3335 530.999 8.20017 530.999 5.00016C530.999 1.80016 533.666 1.3335 534.999 1.50017L547.499 1.50017",
    stroke: "url(#paint6_linear_422_3382)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.499 22.5002C133.332 22.5002 129.399 22.5002 122.999 22.5002C116.599 22.5002 115.332 20.8335 115.499 20.0002C115.499 16.3335 115.499 8.20017 115.499 5.00016C115.499 1.80016 112.832 1.3335 111.499 1.50017L98.999 1.50017",
    stroke: "url(#paint7_linear_422_3382)",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.999 201L57.999 201C59.1657 201.167 62.799 199.8 67.999 193C73.199 186.2 76.1657 182.167 76.999 181",
    stroke: "url(#paint8_linear_422_3382)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M600.999 201L577.999 201C576.832 201.167 573.199 199.8 567.999 193C562.799 186.2 559.832 182.167 558.999 181",
    stroke: "url(#paint9_linear_422_3382)",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9985 222H80.9985C81.9985 221.834 84.5985 220.8 86.9985 218C89.3985 215.2 101.665 200.5 107.499 193.5C108.332 192.334 111.199 190 115.999 190",
    stroke: "url(#paint10_linear_422_3382)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 60.9985,
    y1: 221,
    x2: 60.9985,
    y2: 227,
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9985,
    y1: 206,
    x2: 107.999,
    y2: 206,
    stroke: "url(#paint11_linear_422_3382)",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M574.181 222H554.181C553.181 221.834 550.581 220.8 548.181 218C545.781 215.2 533.514 200.5 527.681 193.5C526.847 192.334 523.981 190 519.181 190",
    stroke: "url(#paint12_linear_422_3382)",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 6,
    y2: -1,
    transform: "matrix(4.43579e-08 1 1 -4.37112e-08 575.181 221)",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 21,
    y2: -1,
    transform: "matrix(-1 0 5.85695e-10 1 548.181 207)",
    stroke: "url(#paint13_linear_422_3382)",
    strokeOpacity: 0.7,
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 71.7908,
    y1: 273.389,
    x2: 98.7908,
    y2: 308.389,
    stroke: "url(#paint14_linear_422_3382)",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 44.2038,
    y2: -1,
    transform: "matrix(-0.610808 0.791788 0.791777 0.610799 564.999 274)",
    stroke: "url(#paint15_linear_422_3382)",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.013 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.088 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.164 193.076)",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M575.236 193.822C575.238 193.41 575.574 193.076 575.986 193.076L584.312 193.076C585.417 193.076 586.307 193.971 586.301 195.076L586.298 195.707C586.292 196.726 585.461 197.552 584.442 197.552L578.945 197.552C576.884 197.552 575.224 195.882 575.236 193.822Z",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3062 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2305 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1548 193.076)",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0749 193.822C61.0772 193.41 60.7451 193.076 60.333 193.076L52.0064 193.076C50.9018 193.076 50.0013 193.971 49.995 195.076L49.9914 195.707C49.9856 196.726 50.8072 197.552 51.8264 197.552L57.3234 197.552C59.3836 197.552 61.0632 195.882 61.0749 193.822Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_3382",
    x1: 1.00001,
    y1: 11.1352,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_3382",
    x1: 1.00001,
    y1: 20.8785,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_422_3382",
    x1: 1.00001,
    y1: 19.4866,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_422_3382",
    x1: 1.00001,
    y1: 36.1894,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_422_3382",
    x1: 1.00001,
    y1: 11.1352,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_422_3382",
    x1: 1.00001,
    y1: 20.8785,
    x2: 1.00001,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_422_3382",
    x1: 533.999,
    y1: 0.500169,
    x2: 524.374,
    y2: 0.0555827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_422_3382",
    x1: 112.499,
    y1: 0.500169,
    x2: 122.124,
    y2: 0.0555827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_422_3382",
    x1: 45.999,
    y1: 217,
    x2: 68.0775,
    y2: 221.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_422_3382",
    x1: 589.999,
    y1: 217,
    x2: 567.921,
    y2: 221.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_422_3382",
    x1: 69.5104,
    y1: 224.378,
    x2: 93.673,
    y2: 236.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_422_3382",
    x1: 86.9985,
    y1: 207.5,
    x2: 107.999,
    y2: 207.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_422_3382",
    x1: 565.669,
    y1: 224.378,
    x2: 541.506,
    y2: 236.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_422_3382",
    x1: 21,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_422_3382",
    x1: 70.6031,
    y1: 274.306,
    x2: 97.6031,
    y2: 309.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_422_3382",
    x1: 0,
    y1: 0.5,
    x2: 44.2038,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame13);
export default __webpack_public_path__ + "static/media/card1-frame13.f90e21a533f4a7ba691400629220552f.svg";
export { ForwardRef as ReactComponent };